import React, {createRef, useEffect} from 'react'
import FJSliderInput from "../../../common/component/slider/FJSliderInput";
import FJLocalStore from "../../../store/FJLocalStore";
import styles from './FJFilterIntensity.module.less'

function FJFilterIntensity(props) {

  const {onChange, value, disabled} = props;
  const slider = createRef();
  const intensityChange = (data) => {
    onChange && onChange(data)
  }

  useEffect(() => {
    slider.current.updateSlider(Math.floor(value));
  });

  return (
    <div className={styles.box}>
      <FJSliderInput name={FJLocalStore._('intensity')}
                     ref={slider}
                     disabled={disabled}
                     callback={intensityChange}
                     min={0}
                     max={100}/>
    </div>
  );
}

export default FJFilterIntensity;